module.exports = __webpack_public_path__ + "static/media/ad1.52a7ee41.jpg";